import { render, staticRenderFns } from "./ESGInsightsByScopeTemp.vue?vue&type=template&id=384c3a28"
import script from "./ESGInsightsByScopeTemp.vue?vue&type=script&lang=js"
export * from "./ESGInsightsByScopeTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports